import Color from '../Color.js';
Color.prototype.premultiply = function () {
  var mutate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var rgb = this._rgb;
  var a = rgb[3];
  if (mutate) {
    this._rgb = [rgb[0] * a, rgb[1] * a, rgb[2] * a, a];
    return this;
  } else {
    return new Color([rgb[0] * a, rgb[1] * a, rgb[2] * a, a], 'rgb');
  }
};